import cx from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import endpoints from "@/utils/endpoints";
import { isAttendeesPage } from "@/utils/is-attendees-page";

import { RingCentralDefaultLogo } from "./ringcentral-default-logo";

const get = endpoints();

type LogoComponentProps = {
  className?: string;
};

const FooterLogo = ({ className }: LogoComponentProps) => {
  const { t } = useTranslation();
  const brand = "RingCentral";
  const href = get("EVENTS_RING_CENTRAL");

  return (
    <div className={className} data-testid="footer-logo">
      <a
        href={isAttendeesPage() ? href : null}
        target="_blank"
        aria-label={`${brand} ${t("common.website")} (${t(
          "common.opens-in-new-window"
        )})`}
        rel="noreferrer noopener"
        className={cx("flex items-center text-decoration-none", className)}
        data-testid="logo"
      >
        <span className="logo-label mr-2 whitespace-nowrap text-xs font-medium text-gray-600">
          {t("common.powered-by")} {brand}
        </span>
        <RingCentralDefaultLogo style={{ height: "1.5rem" }} />
      </a>
    </div>
  );
};

export default FooterLogo;
